import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import { styled } from "@mui/material/styles";
import TableRow from "@mui/material/TableRow";
import {
  Button,
  DialogActions,
  FormControl,
  MenuItem,
  Select,
  Typography,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import DateFnsUtils from "@date-io/date-fns";
import { useEffect } from "react";
import { useState } from "react";
import { toast } from "react-toastify";
import { updateShippingInformation } from "./../../dashboard/actions/dashboardAction";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import {
  formatDate,
  showErrorToast,
} from "../../../../common/components/Helper/Utils";
import CircularProgress from "@material-ui/core/CircularProgress";
import QboInvoice from "./QboInvoice";
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  border: "none",
}));

export default function ShippingInfoUpdateModal(props) {
  const { open, handleClose, invoice, paymentStatus, fetchInvoicesGrid } =
    props;
  const [rows, setRow] = useState([]);
  const [shippingDate, setShippingDate] = useState(null);
  const [trackingNumber, setTrackingNumber] = useState(null);
  const [shippingMethod, setShippingMethod] = useState(null);
  const [shipping, setShipping] = useState(null);
  const [tax, setTax] = useState(null);
  const [fees, setFees] = useState(null);
  const [adjustInvoiceAmount, setAdjustInvoiceAmount] = useState(null);
  const [adjustNotes, setAdjustNotes] = useState(null);
  const [wireDetails, setWireDetails] = useState(false);
  const [zelleDetails, setZelleDetails] = useState(true);
  const [venmoDetails, setVenmoDetails] = useState(true);
  const [deposit, setDeposit] = useState(null);
  const [discount, setDiscount] = useState(null);
  const [notes, setNotes] = useState(null);
  const [soldDate, setSoldDate] = useState(null);
  const [shippingDetails, setShippingDetails] = useState(true);
  const userDetails = sessionStorage.getItem("userDetails")
    ? JSON.parse(sessionStorage.getItem("userDetails"))
    : null;
  const [loading, setLoading] = useState(false);
  const [openQBOInvoiceModal, setOpenQBOInvoiceModal] = useState(false);
  const [qboInvoiceId, setQboInvoiceId] = useState(null);
  const [qboAccountId, setQboAccountId] = useState(null);
  const [originalData, setOriginalData] = useState(null);

  useEffect(() => {
    if (invoice && invoice.id) {
      const solddate = invoice.solddate ? formatDate(invoice.solddate) : null;
      const shippingmethod = invoice.shippingmethod || null;
      const trackingNo = invoice.trackingnumber || null;
      const shippingdate = invoice.shippingdate
        ? formatDate(invoice.shippingdate)
        : null;
      setSoldDate(solddate);
      setShippingDate(shippingdate);
      setTrackingNumber(trackingNo);
      setShippingMethod(shippingmethod);
      setWireDetails(invoice?.wiredetails);
      setZelleDetails(invoice?.zelledetails);
      setVenmoDetails(invoice?.venmodetails);
      setShipping(invoice?.shippingprice);
      setTax(invoice?.tax);
      setFees(invoice?.fees);
      setAdjustInvoiceAmount(invoice?.adjust_amount);
      setAdjustNotes(invoice?.adjust_notes);
      setNotes(invoice?.notes);
      setDeposit(invoice?.deposit);
      setDiscount(invoice?.discount);
      setShippingDetails(invoice?.is_shippingdetails);
      setOriginalData({
        solddate,
        shippingmethod,
        trackingNo,
        shippingdate,
        shippingprice: invoice?.shippingprice,
        tax: invoice?.tax,
        fees: invoice?.fees,
        adjust_amount: invoice?.adjust_amount,
        adjust_notes: invoice?.adjust_notes,
        wiredetails: invoice?.wiredetails,
        zelledetails: invoice?.zelledetails,
        venmodetails: invoice?.venmodetails,
        notes: invoice?.notes,
        deposit: invoice?.deposit,
        discount: invoice?.discount,
        shippingdetails: invoice?.is_shippingdetails,
      });
    }
  }, [invoice]);

  // const isEdited = React.useMemo(() => {
  const normalizeValue = (value) => {
    return value === null || value === undefined ? "" : String(value).trim();
  };

  const isEdited = React.useMemo(() => {
    if (!originalData) return false;

    return (
      normalizeValue(soldDate) !== normalizeValue(originalData.solddate) ||
      normalizeValue(shippingMethod) !==
        normalizeValue(originalData.shippingmethod) ||
      normalizeValue(trackingNumber) !==
        normalizeValue(originalData.trackingNo) ||
      normalizeValue(shippingDate) !==
        normalizeValue(originalData.shippingdate) ||
      normalizeValue(shipping) !== normalizeValue(originalData.shippingprice) ||
      normalizeValue(tax) !== normalizeValue(originalData.tax) ||
      normalizeValue(fees) !== normalizeValue(originalData.fees) ||
      normalizeValue(adjustInvoiceAmount) !==
        normalizeValue(originalData.adjust_amount) ||
      normalizeValue(adjustNotes) !==
        normalizeValue(originalData.adjust_notes) ||
      normalizeValue(wireDetails) !==
        normalizeValue(originalData.wiredetails) ||
      normalizeValue(zelleDetails) !==
        normalizeValue(originalData.zelledetails) ||
      normalizeValue(venmoDetails) !==
        normalizeValue(originalData.venmodetails) ||
      normalizeValue(notes) !== normalizeValue(originalData.notes) ||
      normalizeValue(deposit) !== normalizeValue(originalData.deposit) ||
      normalizeValue(discount) !== normalizeValue(originalData.discount) ||
      normalizeValue(shippingDetails) !==
        normalizeValue(originalData.shippingdetails)
    );
  }, [
    soldDate,
    shippingMethod,
    trackingNumber,
    shippingDate,
    shipping,
    tax,
    fees,
    adjustInvoiceAmount,
    adjustNotes,
    wireDetails,
    zelleDetails,
    venmoDetails,
    notes,
    deposit,
    discount,
    shippingDetails,
    originalData,
  ]);
  //   if (!originalData) return false;

  //   return (
  //     soldDate !== originalData.solddate ||
  //     shippingMethod !== originalData.shippingmethod ||
  //     trackingNumber !== originalData.trackingNo ||
  //     shippingDate !== originalData.shippingdate ||
  //     shipping !== originalData.shippingprice ||
  //     tax !== originalData.tax ||
  //     fees !== originalData.fees ||
  //     adjustInvoiceAmount !== originalData.adjust_amount ||
  //     adjustNotes !== originalData.adjust_notes ||
  //     wireDetails !== originalData.wiredetails ||
  //     zelleDetails !== originalData.zelledetails ||
  //     venmoDetails !== originalData.venmodetails ||
  //     notes !== originalData.notes ||
  //     deposit !== originalData.deposit ||
  //     discount !== originalData.discount ||
  //     shippingDetails !== originalData.shippingdetails
  //   );
  // }, [
  //   soldDate,
  //   shippingMethod,
  //   trackingNumber,
  //   shippingDate,
  //   shipping,
  //   tax,
  //   fees,
  //   adjustInvoiceAmount,
  //   adjustNotes,
  //   wireDetails,
  //   zelleDetails,
  //   venmoDetails,
  //   notes,
  //   deposit,
  //   discount,
  //   shippingDetails,
  //   originalData,
  // ]);

  const updateShippingDetails = () => {
    setLoading(true);
    const data = {
      solddate: soldDate,
      shippingMethod: shippingMethod,
      shippingDate: shippingDate,
      trackingNumber: trackingNumber,
      invoiceId: invoice.id,
      shippingPrice: shipping ? formatPrice(shipping) : "0.00",
      tax: tax ? formatPrice(tax) : "0.00",
      fees: fees ? formatPrice(fees) : "0.00",
      adjust_amount: adjustInvoiceAmount
        ? formatPrice(adjustInvoiceAmount)
        : "0.00",
      adjust_notes: adjustNotes,
      wireDetails: wireDetails,
      zelleDetails: zelleDetails,
      venmoDetails: venmoDetails,
      userId: invoice.userid,
      notes: notes,
      deposit: deposit,
      discount: discount,
      shippingDetails: shippingDetails,
    };
    updateShippingInformation(data, (res, error) => {
      setLoading(false);
      if (res?.status == 1) {
        // toast("Invoice details updated successfully.", {
        //   autoClose: 5000,
        //   type: toast.TYPE.SUCCESS,
        //   position: toast.POSITION.BOTTOM_CENTER,
        // });
        if (res?.qbostatus == 3) {
          toast(res?.message || "QuickBooks warning", {
            position: toast.POSITION.TOP_RIGHT,
            type: toast.TYPE.WARNING,
          });
        } else {
          toast("Invoice details updated successfully", {
            position: toast.POSITION.TOP_RIGHT,
            type: toast.TYPE.SUCCESS,
          });
        }
        // if (props.fetchInvoicesGrid) {
        //   props.fetchInvoicesGrid(null, 1, false);
        // }
        // Check response for QBO sync flag (response shape may vary)
        const qboSynced =
          res?.is_invoice_qbo_synced === true ||
          res?.data?.is_invoice_qbo_synced === true ||
          res?.invoice?.is_invoice_qbo_synced === true;
        const invoiceObj = res?.invoice || res?.data || invoice;
        // Close this modal first
        handleClose();
        if (qboSynced) {
          // Delegate opening the QBO invoice modal to the parent component
          if (typeof props.openQboInvoice === "function") {
            props.openQboInvoice(
              invoiceObj?.id || invoice.id,
              invoiceObj?.accountid || invoice.accountid,
            );
          }
        } else {
          fetchInvoicesGrid?.(null, 1, false);
        }
      } else {
        toast(res?.message || "Failed to update invoice details.", {
          autoClose: 5000,
          type: toast.TYPE.ERROR,
          position: toast.POSITION.BOTTOM_CENTER,
        });
      }
      if (error) {
        showErrorToast(error);
      }
    });
  };

  // const formatPrice = (val) => {
  //   if (val.includes('.')) {
  //     if (val.split('.')[1].length >= 2) {
  //       const num = parseFloat(val);
  //       const cleanNum = num.toFixed(2);
  //       return cleanNum.toString();
  //     }
  //   }
  //   return `${val}.00`;
  // }

  const formatPrice = (val) => {
    const num = parseFloat(val);
    if (isNaN(num)) {
      throw new Error("Invalid number format");
    }
    return num.toFixed(2);
  };

  const onChangeOfCheckBox = (event) => {
    if (event.target.checked === true) {
      setWireDetails(true);
    } else {
      setWireDetails(false);
    }
  };
  const onChangeOfCheckBoxZelle = (event) => {
    if (event.target.checked === true) {
      setZelleDetails(true);
    } else {
      setZelleDetails(false);
    }
  };
  const onChangeOfCheckBoxVenmo = (event) => {
    if (event.target.checked === true) {
      setVenmoDetails(true);
    } else {
      setVenmoDetails(false);
    }
  };

  const onchangeshipping = (event) => {
    if (event.target.checked === true) {
      setShippingDetails(true);
    } else {
      setShippingDetails(false);
    }
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>
          Update Invoice
          <IconButton
            onClick={() => {
              handleClose();
            }}
            style={{ float: "right" }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <TableContainer
            sx={{ maxHeight: 440, marginTop: "20px", marginBottom: "20px" }}
          >
            <Table aria-label="sticky table">
              <TableRow>
                <StyledTableCell colspan={4} style={{ textAlign: "right" }}>
                  SOLD DATE
                </StyledTableCell>
                <StyledTableCell colspan={3}>
                  <FormControl className="form-width-100">
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        id="date-picker-dialog"
                        format="MM/dd/yyyy"
                        value={soldDate}
                        onChange={(date, e) => {
                          setSoldDate(e);
                        }}
                        // isClearable
                        KeyboardButtonProps={{
                          "aria-label": "change date",
                        }}
                        placeholder="MM/DD/YYYY"
                        onPaste={(event) => event.preventDefault()}
                        helperText={""}
                      />
                    </MuiPickersUtilsProvider>
                  </FormControl>
                </StyledTableCell>
              </TableRow>
              <TableRow>
                <StyledTableCell colspan={4} style={{ textAlign: "right" }}>
                  SHIPPING METHOD
                </StyledTableCell>
                <StyledTableCell colspan={3}>
                  <Select
                    onChange={(e) => setShippingMethod(e.target.value)}
                    labelId="demo-simple-select-outlined-label"
                    id="demo-simple-select-outlined"
                    fullWidth
                    value={shippingMethod}
                  >
                    <MenuItem value="USPS">USPS</MenuItem>
                    <MenuItem value="Fedex">Fedex</MenuItem>
                    <MenuItem value="UPS">UPS</MenuItem>
                    <MenuItem value="Ferrari">Ferrari</MenuItem>
                    <MenuItem value="Local Pickup">Local Pickup</MenuItem>
                  </Select>
                </StyledTableCell>
              </TableRow>
              <TableRow>
                <StyledTableCell colspan={4} style={{ textAlign: "right" }}>
                  TRACKING NUMBER
                </StyledTableCell>
                <StyledTableCell colspan={3}>
                  <input
                    className="form-width-100"
                    type="text"
                    placeholder="Tracking Number"
                    style={{ height: "30px" }}
                    value={trackingNumber}
                    onChange={(e) => setTrackingNumber(e.target.value)}
                    maxLength={150}
                  />
                </StyledTableCell>
              </TableRow>
              <TableRow>
                <StyledTableCell colspan={4} style={{ textAlign: "right" }}>
                  SHIPPING DATE
                </StyledTableCell>
                <StyledTableCell colspan={3}>
                  <FormControl className="form-width-100">
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        id="date-picker-dialog"
                        format="MM/dd/yyyy"
                        value={shippingDate}
                        onChange={(date, e) => {
                          setShippingDate(e);
                        }}
                        // isClearable
                        KeyboardButtonProps={{
                          "aria-label": "change date",
                        }}
                        placeholder="MM/DD/YYYY"
                        onPaste={(event) => event.preventDefault()}
                        helperText={""}
                      />
                    </MuiPickersUtilsProvider>
                  </FormControl>
                </StyledTableCell>
              </TableRow>
              <TableRow>
                <StyledTableCell colspan={4} style={{ textAlign: "right" }}>
                  SHIPPING (ACCUMULATED)
                </StyledTableCell>
                <StyledTableCell colspan={3}>
                  <input
                    type="text"
                    className="form-width-100"
                    placeholder="$0.00"
                    style={{ height: "30px" }}
                    value={shipping}
                    onChange={(e) =>
                      setShipping(e.target.value.replace(/[^0-9\.]/g, ""))
                    }
                    disabled={paymentStatus === "Fully Paid"}
                  />
                </StyledTableCell>
              </TableRow>
              <TableRow>
                <StyledTableCell colspan={4} style={{ textAlign: "right" }}>
                  NOTES
                </StyledTableCell>
                <StyledTableCell colspan={3}>
                  <input
                    className="form-width-100"
                    type="text"
                    placeholder="Notes"
                    style={{ height: "30px" }}
                    value={notes}
                    onChange={(e) => {
                      setNotes(e.target.value);
                    }}
                    disabled={paymentStatus === "Fully Paid"}
                  />
                </StyledTableCell>
              </TableRow>
              <TableRow>
                <StyledTableCell colspan={4} style={{ textAlign: "right" }}>
                  TAX (ACCUMULATED)
                </StyledTableCell>
                <StyledTableCell colspan={3}>
                  <input
                    className="form-width-100"
                    type="text"
                    placeholder="$0.00"
                    style={{ height: "30px" }}
                    value={tax}
                    onChange={(e) =>
                      setTax(e.target.value.replace(/[^0-9\.]/g, ""))
                    }
                    disabled={
                      paymentStatus === "Fully Paid" &&
                      !(
                        userDetails?.roleId === 2 ||
                        userDetails?.roleId === 3 ||
                        userDetails?.roleId === 6
                      )
                    }
                  />
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell colspan={4} style={{ textAlign: "right" }}>
                  FEES (ACCUMULATED)
                </StyledTableCell>
                <StyledTableCell colspan={3}>
                  <input
                    className="form-width-100"
                    type="text"
                    placeholder="$0.00"
                    style={{ height: "30px" }}
                    value={fees}
                    onChange={(e) =>
                      setFees(e.target.value.replace(/[^0-9\.]/g, ""))
                    }
                    disabled={paymentStatus === "Fully Paid"}
                  />
                </StyledTableCell>
              </TableRow>
              <TableRow>
                <StyledTableCell colspan={4} style={{ textAlign: "right" }}>
                  FINAL INVOICE ADJUSTMENT (ACCUMULATED)
                </StyledTableCell>
                <StyledTableCell colspan={3}>
                  <input
                    className="form-width-100"
                    type="text"
                    placeholder="$0.00"
                    style={{ height: "30px" }}
                    value={adjustInvoiceAmount}
                    onChange={(e) =>
                      setAdjustInvoiceAmount(
                        e.target.value.replace(/[^0-9\.\-]|(?!^)-/g, ""),
                      )
                    }
                    disabled={paymentStatus === "Fully Paid"}
                  />
                </StyledTableCell>
              </TableRow>
              <TableRow>
                <StyledTableCell colspan={4} style={{ textAlign: "right" }}>
                  ADJUSTMENT NOTES
                </StyledTableCell>
                <StyledTableCell colspan={3}>
                  <input
                    className="form-width-100"
                    type="text"
                    placeholder="Notes"
                    style={{ height: "30px" }}
                    value={adjustNotes}
                    onChange={(e) => setAdjustNotes(e.target.value)}
                    disabled={paymentStatus === "Fully Paid"}
                  />
                </StyledTableCell>
              </TableRow>
              <TableRow>
                <StyledTableCell colspan={4} style={{ textAlign: "right" }}>
                  Include Wire Details
                </StyledTableCell>
                <StyledTableCell colspan={3}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="checkedB1"
                        className="float-right"
                        checked={wireDetails}
                        onChange={onChangeOfCheckBox}
                      />
                    }
                    disabled={paymentStatus === "Fully Paid"}
                  />
                </StyledTableCell>
              </TableRow>
              <TableRow>
                <StyledTableCell colspan={4} style={{ textAlign: "right" }}>
                  Include Zelle Details
                </StyledTableCell>
                <StyledTableCell colspan={3}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="checkedB1"
                        className="float-right"
                        checked={zelleDetails}
                        onChange={onChangeOfCheckBoxZelle}
                      />
                    }
                    disabled={paymentStatus === "Fully Paid"}
                  />
                </StyledTableCell>
              </TableRow>
              <TableRow>
                <StyledTableCell colspan={4} style={{ textAlign: "right" }}>
                  Include Venmo Details
                </StyledTableCell>
                <StyledTableCell colspan={3}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="checkedB1"
                        className="float-right"
                        checked={venmoDetails}
                        onChange={onChangeOfCheckBoxVenmo}
                      />
                    }
                    disabled={paymentStatus === "Fully Paid"}
                  />
                </StyledTableCell>
              </TableRow>
              <TableRow>
                <StyledTableCell colspan={4} style={{ textAlign: "right" }}>
                  Include Shipping Details
                </StyledTableCell>
                <StyledTableCell colspan={3}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="checkedB1"
                        className="float-right"
                        checked={shippingDetails}
                        onChange={onchangeshipping}
                      />
                    }
                    // disabled={paymentStatus === "Fully Paid"}
                  />
                </StyledTableCell>
              </TableRow>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            onClick={handleClose}
            style={{
              background: "#fff",
              color: "#000",
            }}
          >
            {" "}
            Cancel
          </Button>
          <Button
            variant="text"
            onClick={(e) => {
              if (loading || !isEdited) {
                e.preventDefault();
                e.stopPropagation();
                return;
              }
              updateShippingDetails(e);
            }}
            disabled={!isEdited || loading}
            style={{
              background: !isEdited || loading ? "#ccc" : "#000",
              color: "#fff",
              marginRight: "10px",
              cursor: !isEdited || loading ? "not-allowed" : "pointer",
            }}
            endIcon={
              loading ? (
                <CircularProgress
                  style={{ width: 22, height: 22, color: "#fff" }}
                />
              ) : null
            }
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
      <QboInvoice
        open={openQBOInvoiceModal}
        invoiceId={qboInvoiceId}
        accountId={qboAccountId}
        // handleClose={() => setOpenQBOInvoiceModal(false)}
      />
    </>
  );
}
